import React from "react";
import ProgramDetailsSection from "../../../../components/template/ProgramDetailSection";

const Thrive = () => {
  return (
    <ProgramDetailsSection
      title="THRIVE"
      tagline="Inner Excellence Workshop"
      highlights={[
        "High-trust teams",
        "Purpose-driven performance",
        "Culture transformation",
      ]}
      description="THRIVE is a transformational workshop that helps teams cultivate trust, collaboration, purpose, and inner excellence to create sustainable high performance and organizational wellbeing."
      duration="1.5 Days"
      focusAreas={[
        "Inner Excellence",
        "Trust & Collaboration",
        "Team Alignment",
        "Flourishing Culture",
        "Purpose-Driven Performance",
      ]}
      outcomes={[
        "Build high-trust teams that collaborate with greater ownership and alignment.",
        "Create a culture that supports both wellbeing and exceptional performance.",
        "Foster collective excellence where individuals, teams, and the organization thrive together.",
      ]}
      images={[
         "../../../cw/CW17.JPG",
          "../../../cw/CW16.JPG",
           "../../../cw/CW14.JPG"
      ]}
    />
  );
};

export default Thrive;